import React, { useEffect, useState } from 'react'
import { TimeAnalytics } from '../../../services'
import { TrendingUp, Calendar } from 'lucide-react'

function TimeActivity() {
  const [timeAnalytics, setTimeAnalytics] = useState([])
  const [loading, setLoading] = useState(true)

  const timeAnalyticsData = async () => {
    try {
      setLoading(true)
      const res = await TimeAnalytics()
      setTimeAnalytics(res)
    } catch (error) {
      console.error('Error fetching activity logs:', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    timeAnalyticsData()
  }, [])

  if (loading) {
    return (
      <div className="bg-white rounded-lg shadow-md p-6 mb-6">
        <div className="animate-pulse">
          <div className="h-6 bg-gray-200 rounded w-1/3 mb-4"></div>
          <div className="h-64 bg-gray-200 rounded"></div>
        </div>
      </div>
    )
  }

  // Get max value for scaling
  const maxCount = Math.max(...timeAnalytics.map(item => item.count || 0), 1)

  return (
    <div className="bg-white rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 p-6 mb-6 border border-gray-100">
      <div className="flex items-center mb-6">
        <div className="bg-gradient-to-r from-blue-500 to-cyan-500 p-3 rounded-lg mr-4">
          <TrendingUp className="w-6 h-6 text-white" />
        </div>
        <div>
          <h2 className="text-xl font-bold text-gray-800">Time Analytics</h2>
          <p className="text-sm text-gray-500">Track user activity patterns over time</p>
        </div>
      </div>

      {timeAnalytics.length === 0 ? (
        <div className="text-center py-12">
          <div className="bg-gray-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
            <Calendar className="w-8 h-8 text-gray-400" />
          </div>
          <p className="text-gray-500">No time analytics data found</p>
        </div>
      ) : (
        <div className="space-y-3">
          {timeAnalytics.map((item, index) => {
            const heightPercent = ((item.count / maxCount) * 100).toFixed(1)
            
            return (
              <div key={index} className="flex items-center group">
                <div className="w-24 flex-shrink-0">
                  <span className="text-sm font-medium text-gray-700">
                    {item.day || 'Unknown'}
                  </span>
                </div>
                <div className="flex-1 flex items-center">
                  <div className="relative w-full">
                    <div
                      className="bg-gradient-to-r from-blue-500 to-cyan-500 h-10 rounded-r-lg transition-all duration-500 ease-out group-hover:from-blue-600 group-hover:to-cyan-600"
                      style={{ width: `${heightPercent}%` }}
                    ></div>
                    <div className="absolute inset-0 flex items-center px-3">
                      <span className="text-sm font-semibold text-white">
                        {item.count?.toLocaleString() || 0}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      )}

      {timeAnalytics.length > 0 && (
        <div className="mt-6 pt-4 border-t border-gray-200">
          <div className="grid grid-cols-2 gap-4 text-sm">
            <div>
              <span className="text-gray-500">Total Days</span>
              <p className="text-lg font-bold text-gray-800">{timeAnalytics.length}</p>
            </div>
            <div>
              <span className="text-gray-500">Total Activities</span>
              <p className="text-lg font-bold text-gray-800">
                {timeAnalytics.reduce((sum, item) => sum + (item.count || 0), 0).toLocaleString()}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default TimeActivity